import React, { useEffect, useState } from "react";
import CheckBox from "../../Checkbox/index";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchCommunicationListRequest,
  updateCommunicationRequest,
} from "../../../containers/AdminPanel/reducers/communicationSlice";
import DynamicTable from "../../Table";
import useLiveRefresh from "@utils/useLiveRefresh";

const ManageCommunication = () => {
  const constant_communication_fields = {
    LICENSE_REQUIRED: "license_required",
    LICENSE_EXPIRED: "license_expired",
    MANAGE_COMMUNICATION: "Manage Communication",
    CONTACT_INSURED: "Contact Insured",
    STATE: "State",
    VALIDATE_LICENSE_NUMBER: "Validate License Number",
    VALIDATE_EXPIRATION_DATE: "Validate Expiration Date",
  };

  const dispatch = useDispatch();

  const communicationList = useSelector(
    (state) => state.adminPanel.communicationData.communicationList,
  );

  const [localCommunicationData, setlocalCommunicationData] = useState([]);

  // Fetch on mount
  useEffect(() => {
    dispatch(fetchCommunicationListRequest());
  }, [dispatch]);

  // organization.communication.updated is emitted after the org service saves
  // the state rules, so this picks up a change made by another admin.
  useLiveRefresh(["organization"], () => {
    dispatch(fetchCommunicationListRequest());
  });

  // Sync redux → local
  useEffect(() => {
    if (communicationList) {
      setlocalCommunicationData(communicationList);
    }
  }, [communicationList]);

  // Toggle handler
  const handleToggle = (state_code, key) => {
    const updated = localCommunicationData.map((item) => {
      if (item.state_code === state_code) {
        return {
          ...item,
          [key]: !item[key],
        };
      }
      return item;
    });
    setlocalCommunicationData(updated);
    dispatch(updateCommunicationRequest(updated));
  };

  const handleSelectAll = (field, value) => {
    const updated = localCommunicationData.map((item) => ({
      ...item,
      [field]: value,
    }));

    setlocalCommunicationData(updated);
    dispatch(updateCommunicationRequest(updated));
  };

  const isAllChecked = (field) => {
    if (!localCommunicationData.length) return false;
    return localCommunicationData.every((item) => !!item[field]);
  };

  //Dynamic Table Columns
  const columns = [
    {
      key: "state",
      header: constant_communication_fields.STATE,
      render: (row) => `${row.state_name} (${row.state_code})`,
    },
    {
      key: "license",
      headerRender: () => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <CheckBox
            item={{
              id: "select-all-license",
              checked: isAllChecked(
                constant_communication_fields.LICENSE_REQUIRED,
              ),
              label: "",
            }}
            onChange={() =>
              handleSelectAll(
                constant_communication_fields.LICENSE_REQUIRED,
                !isAllChecked(constant_communication_fields.LICENSE_REQUIRED),
              )
            }
          />
          <span>{constant_communication_fields.VALIDATE_LICENSE_NUMBER}</span>
        </div>
      ),
      render: (row) => (
        <CheckBox
          item={{
            id: `${row.state_code}-license`,
            checked: row.license_required,
            label: "",
          }}
          onChange={() =>
            handleToggle(
              row.state_code,
              constant_communication_fields.LICENSE_REQUIRED,
            )
          }
        />
      ),
    },
    {
      key: "expiry",
      headerRender: () => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <CheckBox
            item={{
              id: "select-all-expiry",
              checked: isAllChecked(
                constant_communication_fields.LICENSE_EXPIRED,
              ),
              label: "",
            }}
            onChange={() =>
              handleSelectAll(
                constant_communication_fields.LICENSE_EXPIRED,
                !isAllChecked(constant_communication_fields.LICENSE_EXPIRED),
              )
            }
          />
          <span>{constant_communication_fields.VALIDATE_EXPIRATION_DATE}</span>
        </div>
      ),
      render: (row) => (
        <CheckBox
          item={{
            id: `${row.state_code}-expiry`,
            checked: row.license_expired,
            label: "",
          }}
          onChange={() =>
            handleToggle(
              row.state_code,
              constant_communication_fields.LICENSE_EXPIRED,
            )
          }
        />
      ),
    },
  ];

  return (
    <div>
      <div className="colFlex admin__header">
      <h1>{constant_communication_fields.MANAGE_COMMUNICATION}</h1>
      <h3 className="mt__1 mb"><label>{constant_communication_fields.CONTACT_INSURED}</label></h3>
      </div>
      <div className="admin__container__data admin__container__data--communication">
      <DynamicTable columns={columns} data={localCommunicationData} />
      </div>
    </div>
  );
};

export default ManageCommunication;
